export default "__VITE_ASSET__Aigl6E1g__"